import { Field, Model, CodeModel, FIELD_TYPES } from "../../vue-ocom/schema";

export default Model("document_history", {
  verbose_name: "Document History",
  verbose_name_plural: "Document Histories",
  fields: [
    Field("id", {
      label: "ID",
      primary_key: true,
      readonly: true,
      hide: false,
      field_type: FIELD_TYPES.AutoNumber,
    }),

    Field("when", {
      label: "When",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.Date,
      default: () => {
        return new Date().toISOString().split("T")[0];
      },
    }),
    Field("document", {
      label: "Document",
      primary_key: false,
      readonly: false,
      required: false,
      hide: false,
      field_type: FIELD_TYPES.ForeignKey,
      ref_field_type: "Document",
      ref_display_field: "created_date",
      default: () => {
        return null;
      },
    }),
    Field("document_version", {
      label: "Document Version",
      primary_key: false,
      readonly: false,
      required: false,
      hide: false,
      field_type: FIELD_TYPES.ForeignKey,
      ref_field_type: "DocumentVersion",
      ref_display_field: "name",
      default: () => {
        return null;
      },
    }),
    Field("details", {
      label: "Details",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.String,
      default: () => {
        return "";
      },
    }),
  ],
});
